import { render, staticRenderFns } from "./InfoBlurb.vue?vue&type=template&id=3b4a4bb2&scoped=true&"
var script = {}
import style0 from "./InfoBlurb.vue?vue&type=style&index=0&id=3b4a4bb2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a4bb2",
  null
  
)

export default component.exports